import { AuditLogCategory, Auditable, Case, FormData, QueryParams, SortParams, Tissue } from "..";

export interface AuditLogEntry extends Auditable {
    auditLogCategoryId?: number;
    caseId?: number;
    userId?: number;
    userName?: string;
    formDataId?: number;
    tissueId?: number;
    procedureId?: number;
    orderId?: number;
    surgeryId?: number;
    invoiceId?: number;
    accountId?: number;
    action: string;
    dataType: string;
    description?: string;
    changes?: string;

    case?: Case;
    formData?: FormData;
    tissue?: Tissue;
    auditLogCategory?: AuditLogCategory;
}

export const DefaultAuditLogEntryQueryParams: QueryParams = {
    caseId: "",
    userId: "",
    auditLogCategoryId: "",
    formId: "",
    action: "",
    dataType: "",
    description: "",
    timeLow: "",
    timeHigh: "",
    changes: "",
};

export const DefaultAuditLogEntrySortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "true",
};
